export default {"src":"/_next/static/media/domain.d5caec15.svg","height":610,"width":952,"blurWidth":0,"blurHeight":0};